import React, { useState } from 'react';
import styled from 'styled-components';
import { mediaBreakpointDown } from '../../utils/styling';
import { trackCustomEvent } from "gatsby-plugin-google-analytics";
import bg from "../../images/smbBanner.png";
import Icon from "../../images/smbIcon.png";

const Background = styled.div`
	width: 100%;
	// padding: 20px 0;
	border-radius: 10px;
	background: url(${bg});
	max-width: 800px;
	display: flex;
	align-items: center;
	width: 100%;
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center center;

	${mediaBreakpointDown('md')} {
		padding: 0 0;
	}
	${mediaBreakpointDown('sm')} {
		background-image: linear-gradient(156deg, #CF75FF 4%, #FF8EC0 51%, #FFB88E 89%);
		background-size: cover;
		margin-bottom: 0;
		padding: 10px 10px 0 10px;
	}
	@media screen and (min-width: 992px) and (max-width: 1200px) {
		background-image: linear-gradient(156deg, #CF75FF 4%, #FF8EC0 51%, #FFB88E 89%);
	}
`;
const BackgroundContainer = styled.div`
	display: flex;
	align-items: center;
	width: 100%;

	${mediaBreakpointDown('sm')} {
		flex-direction: column;
		margin-bottom: 0;
		padding-bottom: 0;
	}
`;
const Form = styled.form`
	flex-basis: 50%;
	width: 100%;
	padding: 0 20px;

	${mediaBreakpointDown('md')} {
		padding: 0 20px;
	}
	${mediaBreakpointDown('sm')} {
		margin-bottom: 20px;
	}
	@media screen and (min-width: 992px) and (max-width: 1200px) {
		flex-basis: 100%;
	}
`;
const FormContainer = styled.div`
	max-width: 400px;
	${mediaBreakpointDown('sm')} {
		margin: auto;
	}
	@media screen and (min-width: 992px) and (max-width: 1200px) {
		margin: auto;
	}
`;
const Title = styled.div`
	font-weight: bold;
	color: #fff;
	font-size: 22px;
	line-height: 24px;
	margin: 10px 0 10px 0;
	${mediaBreakpointDown('md')} {
	}
	${mediaBreakpointDown('sm')} {
		text-align: center;
		font-size: 25px;
		line-height: 27px;
	}
	@media screen and (min-width: 992px) and (max-width: 1200px) {
		text-align: center;
	}

`;
const InputContainer = styled.div`
	display: flex;
	background-color: #ffffff;
	border-radius: 8px;
	align-items: center;
	margin-bottom: 18px;

	> svg {
		margin-left: 13px;
		margin-right: 5px;
	}
`;
const Input = styled.input`
	border: none;
	outline: none;
	background: transparent;
	font-weight: 600;
	font-size: 16px;
	flex: 1 1;
	padding: 13px;
	width: 100%;
	::placeholder,
	::-webkit-input-placeholder {
	  color: #ddd;
	}
	:-ms-input-placeholder {
	   color: #ddd;
	}
`;
const ButtonContainer = styled.button`
	background-color: #e01ec6;
	color: #fff;
	padding: 14px 20px;
	border-radius: 8px;
	font-weight: bold;
	font-size: 14px;
	width: 100%;
	text-align: center;
	cursor: pointer;
	margin-bottom: 15px;
	// box-shadow: 0px 0px 1px; #ccc;
`;
const Testinomial = styled.div`
	flex-basis: 50%;
	padding: 0px 20px 0 0;
	display: flex;
	flex-direction: column;
	align-items: end;
	justify-content: end;


	${mediaBreakpointDown('md')} {
		padding: 60px 20px 0 0;
	}

	${mediaBreakpointDown('sm')} {
		display: none;
	}
	@media screen and (min-width: 992px) and (max-width: 1200px) {
		display: none;
	}
`;
const Image = styled.img`
	width: 275px !important;
`;
function SMBCTAForm({ cta, title, button = 'Sign Up' }) {
	const [email, setEmail] = useState('');
	const validEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
		email,
	);

	return (
		<Background className={'ctaForm'}>
			<BackgroundContainer>
				<Form
					onSubmit={(e) => {
						e.preventDefault();
						trackCustomEvent({
							category: "Entire page tracker",
							action: "click",
							label: "Submit Form",
						});
						trackCustomEvent({
							category: "In-content CTAs clicks",
							action: "click",
							label: "Submit Form",
						})
						if (validEmail) {
							window.location.href = `${process.env.MAIN_SITE_URL}/business?email=${encodeURIComponent(email)}&cta=${cta}`;
						}
					}}
				>
					<Title>{title || 'Sign Up For our small business product'}</Title>
					<FormContainer>
						<InputContainer>
							<Input
								value={email}
								placeholder="example@email.com"
								onChange={(e) => setEmail(e.target.value.toLowerCase().replace(/\s/g, ''))}
							/>
						</InputContainer>

						<ButtonContainer type="submit" className="cta-form-ga">
							{button || 'Sign up'}
						</ButtonContainer>
					</FormContainer>
				</Form>
				<Testinomial>
					<div>
						<Image alt="Protect your business" src={Icon} />
					</div>
				</Testinomial>
			</BackgroundContainer>
		</Background>
	);
}

export default React.memo(SMBCTAForm);
